import { Guid } from "@common/guid";

export class SystemDisplayFieldRequest {
    selectedFields: SystemFieldOrderItem[] = [];

    constructor(fields: Array<string>, filterIdToEnumMap: Record<string, SystemColumn | undefined>) {
        fields.forEach((x, index) => {
            if (Guid.isGuid(x)) {
                this.selectedFields.push({ customFieldId: x, displayOrder: index });
            } else {
                this.selectedFields.push({ column: filterIdToEnumMap[x], displayOrder: index });
            }
        });
    }
}

export class SystemFieldOrderItem {
    column?: SystemColumn;
    customFieldId?: string;
    displayOrder: number = 0;
}

export enum SystemColumn {
    Id,
    UserFriendlyId,
    Name,
    Template,
    Status,
    Description,
    Type,
    EntityType,
    Responsible,
    BusinessAreas,
    IsCriticalForOperation,
    OperationCriticalityLevel,
    Certifications,
    UsesAI,
    DataStorageLocations,
    SupportAccessLocations,
    Note,
    DeletionPeriod,
    DeletionPeriodReason,
    StorageType,
    Network,
    AIUsageDescription,
    CompanyUsesAIService,
    IsUseOfAIConsideredHighRisk,
    IsDataUsedForTrainingOfAIModel,
    SecurityMeasures,
    Suppliers,
    Policies,
    DataTypes,
    RiskAssessmentScore,
    AssociatedAssets,
    AccessBusinessAreas,
    GroupEntityAccess,
    VisibleToAllUsers,
    AdditionalUsers,
    ExcludedUsers,
    Tags,
    SecondarySuppliers,
    DataCategories,
    DataSubjects,
    ProcessingActivities,
    DataProcessorAgreement,
    TransferBases,
    DataProcessorLocations,
    HasSupplier,
    Icon,
}

export function getFilterIdByEnum(enumValue: SystemColumn, filterIdToEnumMap: Record<string, SystemColumn | undefined>): string | undefined {
    return filterIdToEnumMap ? Object.keys(filterIdToEnumMap).find((key) => filterIdToEnumMap[key] === enumValue) : undefined;
}
